// extracted by mini-css-extract-plugin
module.exports = {"edit":"DeliveryAddress_edit_3UQIY","address_str":"DeliveryAddress_address_str_35ins"};